import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { isValidTranslateExcelOrderId, TranslateExcelOrderBusiness } from '../coreDomainsModule/translateExcelOrder';

/**
 * 発注エクセル取り込みに使用する集計取引を区別するためのIDを管理するためのクラス
 */
export class TranslateExcelOrderIdManager {
  /**
   * 集計情報のみ区別する必要があるので、
   * 「置場CD、容量、商品CD、仕入先CD」から読み取り/出力用ののIDを作成する
   * @param translateOrder - エクセル読み取り/出力用の発注情報
   */
  public static generateOrderIdFormExcelInput = (translateOrder: TranslateExcelOrderBusiness): string => {
    // 集計を区別するために必要な要素が欠けていないか確認
    if (!isValidTranslateExcelOrderId(translateOrder)) return '';
    const output: string =
      (translateOrder.warehouseNumber ?? '') +
      (translateOrder.businessNumber ?? '') +
      (translateOrder.package ?? '') +
      (translateOrder.supplierNumber ?? '');

    if (output === '') return UNASSIGNED_COLUMN;
    return output;
  };
}
